import { useSelector } from 'react-redux';
import { Button, Col, Collapse, Input, Row, Form, Switch, Select, DatePicker, Divider } from 'antd';
import { dateFormat } from '../../utils/constants';
import { handleDateConvertForApis } from '../../utils/functions';

const Filters = ({ onFilterData, onResetData, filterValues, filtersInitValues, totalDocNr, pageNumber, pageSize, }) => {

    const [form] = Form.useForm();
    const { RangePicker } = DatePicker;
    const suppliersList = useSelector(state => state.suppliers.suppliers);
    const documentStatusList = useSelector(state => state.docStatus.docStatus);
    const intervetionTypesList = useSelector(state => state.intervetionTypes.intervetionTypes);
    const totalPages = Math.ceil(totalDocNr / pageSize);

    const onClearFilter = () => {
        form.setFieldsValue(filtersInitValues);
        onResetData();
    }

    const onFilter = (values) => {
        if (values.dateAddedRange && values.dateAddedRange.length > 0) {
            let dateAddedPicker = values.dateAddedRange;
            values["dateAddedFrom"] = handleDateConvertForApis(dateAddedPicker[0].$d);
            values["dateAddedTo"] = handleDateConvertForApis(dateAddedPicker[1].$d);
        }

        if (values.dateUpdatedRange && values.dateUpdatedRange.length > 0) {
            let lastUpdatedDatePicker = values.dateUpdatedRange;
            values["lastUpdatedDateFrom"] = handleDateConvertForApis(lastUpdatedDatePicker[0].$d);
            values["lastUpdatedDateTo"] = handleDateConvertForApis(lastUpdatedDatePicker[1].$d);
        }
        onFilterData(values);
    };

    const FilterContent = () => {
        return (
            <div className='documentFilters'>
                <Row gutter={[16, 16]} className='rowmb0'>
                    <Col className="gutter-row" xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 24 }} lg={{ span: 24 }}>
                        <Form
                            form={form}
                            name="filters"
                            layout="vertical"
                            onFinish={onFilter}
                            autoComplete="off"
                        >
                            <Row gutter={{ lg: 24 }} className='rowmb0'>
                                <Col className="gutter-row" xs={{ span: 24 }} sm={{ span: 6 }} md={{ span: 4 }} lg={{ span: 4 }}>
                                    <Form.Item
                                        label="Codice Univoco"
                                        name="code"
                                        initialValue={filterValues.code}
                                    >
                                        <Input placeholder="Codice Univoco" onClear={() => form.submit()} allowClear />
                                    </Form.Item>
                                </Col>

                                <Col className="gutter-row" xs={{ span: 24 }} sm={{ span: 6 }} md={{ span: 4 }} lg={{ span: 4 }}>
                                    <Form.Item
                                        label="Manutentore"
                                        name="supplierId"
                                        initialValue={filterValues.supplierId}
                                    >
                                        <Select
                                            showSearch
                                             optionFilterProp="label"
                                            placeholder="Manutentore"
                                            allowClear={true}
                                            options={suppliersList}
                                            onChange={() => form.submit()}
                                        />
                                    </Form.Item>
                                </Col>

                                <Col className="gutter-row" xs={{ span: 24 }} sm={{ span: 6 }} md={{ span: 4 }} lg={{ span: 4 }}>
                                    <Form.Item
                                        label="Intervento"
                                        name="interventionTypeId"
                                        initialValue={filterValues.interventionTypeId}
                                    >
                                        <Select
                                            showSearch
                                            optionFilterProp="label"
                                            placeholder="Intervento"
                                            allowClear={true}
                                            options={intervetionTypesList}
                                            onChange={() => form.submit()}
                                        />
                                    </Form.Item>
                                </Col>

                                <Col className="gutter-row" xs={{ span: 24 }} sm={{ span: 6 }} md={{ span: 4 }} lg={{ span: 4 }}>
                                    <Form.Item
                                        label="Stato"
                                        name="workingStatusId"
                                        initialValue={filterValues.workingStatusId}
                                    >
                                        <Select
                                            showSearch
                                            optionFilterProp="label"
                                            placeholder="Stato"
                                            allowClear={true}
                                            options={documentStatusList}
                                            onChange={() => form.submit()}
                                        />
                                    </Form.Item>
                                </Col>

                                <Col className="gutter-row" xs={{ span: 24 }} sm={{ span: 6 }} md={{ span: 4 }} lg={{ span: 4 }}>
                                    <Form.Item
                                        label="Anomalia"
                                        name="anomaly"
                                        initialValue={filterValues.anomaly}
                                    >
                                        <Input placeholder='Anomalie' onClear={() => form.submit()} allowClear />
                                    </Form.Item>
                                </Col>

                                <Col className="gutter-row" xs={{ span: 24 }} sm={{ span: 6 }} md={{ span: 4 }} lg={{ span: 4 }}>
                                    <Form.Item
                                        label="Operatore"
                                        name="operatore"
                                        initialValue={filterValues.operatore}
                                    >
                                        <Input placeholder='Operatore' onClear={() => form.submit()} allowClear />
                                    </Form.Item>
                                </Col>

                                <Col className="gutter-row" xs={{ span: 24 }} sm={{ span: 6 }} md={{ span: 5 }} lg={{ span: 5 }}>
                                    <Form.Item
                                        label="Data caricamento"
                                        name="dateAddedRange"
                                        initialValue={filterValues.dateAddedRange}
                                    >
                                        <RangePicker
                                            style={{ width: "100%" }}
                                            format={dateFormat}
                                            placeholder={["Data d'inizio", 'Data di fine']}
                                            onChange={() => form.submit()}
                                            allowClear={true} />
                                    </Form.Item>
                                </Col>

                                <Col className="gutter-row" xs={{ span: 24 }} sm={{ span: 6 }} md={{ span: 5 }} lg={{ span: 5 }}>
                                    <Form.Item
                                        label="Data modifica"
                                        name="dateUpdatedRange"
                                        initialValue={filterValues.dateUpdatedRange}
                                    >
                                        <RangePicker
                                            style={{ width: "100%" }}
                                            format={dateFormat}
                                            placeholder={["Data d'inizio", 'Data di fine']}
                                            onChange={() => form.submit()}
                                            allowClear={true} />
                                    </Form.Item>
                                </Col>

                                <Col className="gutter-row" xs={{ span: 24 }} sm={{ span: 6 }} md={{ span: 4 }} lg={{ span: 4 }}>
                                    <Form.Item
                                        label="Batch"
                                        name="flux"
                                        initialValue={filterValues.flux}
                                    >
                                        <Input placeholder='Batch' onClear={() => form.submit()} allowClear />
                                    </Form.Item>
                                </Col>


                                <Col className="gutter-row" xs={{ span: 24 }} sm={{ span: 6 }} md={{ span: 4 }} lg={{ span: 4 }}>
                                    <Form.Item
                                        label="File Comunicazione"
                                        name="fileCommunicazioneName"
                                        initialValue={filterValues.fileCommunicazioneName}
                                    >
                                        <Input placeholder='File Comunicazione' onClear={() => form.submit()} allowClear />
                                    </Form.Item>
                                </Col>

                                <Col className="gutter-row" xs={{ span: 24 }} sm={{ span: 6 }} md={{ span: 3 }} lg={{ span: 3 }}>
                                    <Form.Item
                                        label="Note Presenti"
                                        name="hasNotes"
                                        valuePropName="checked"
                                        initialValue={filterValues.hasNotes}
                                    >
                                        <Switch onChange={() => form.submit()} />
                                    </Form.Item>
                                </Col>

                                <Col className="gutter-row" xs={{ span: 24 }} sm={{ span: 6 }} md={{ span: 3 }} lg={{ span: 3 }}>
                                    <Form.Item
                                        label="Anomalie Presenti"
                                        name="hasAnomaly"
                                        valuePropName="checked"
                                        initialValue={filterValues.hasAnomaly}
                                    >
                                        <Switch onChange={() => form.submit()} />
                                    </Form.Item>
                                </Col>
                            </Row>

                            <Divider />

                            <Row gutter={{ lg: 24 }}>
                                <Col className="gutter-row filterButtons" xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 24 }} lg={{ span: 24 }}>
                                    <Form.Item style={{ marginBottom: 0 }}>
                                        <Button className='mr10' type="primary" htmlType="submit">Filtra</Button>
                                    </Form.Item>
                                    <Form.Item style={{ marginBottom: 0 }}>
                                        <Button onClick={() => onClearFilter()}>Rimuovi</Button>
                                    </Form.Item>
                                </Col>
                            </Row>

                        </Form>
                    </Col>
                </Row>
            </div>
        )
    }

    return (
        <>
            <Collapse
                size='small'
                defaultActiveKey={['1']}
                items={[
                    {
                        key: '1',
                        label: `Filtra documenti - Visualizzando ${totalDocNr} documenti (Pagina: ${pageNumber}/${totalPages})`,
                        children: <FilterContent />
                    },
                ]}
            />
        </>
    );
}

export default Filters;